import { gql } from '@apollo/client'

export const SET_NEXT_APPRAISAL_SEASON_OPENING_DATE = gql`
  mutation SetNextAppraisalSeasonOpeningDate(
    $companyId: HashedId!
    $country: Country!
    $year: Int!
    $openingMonth: Int!
    $openingYear: Int!
  ) {
    setNextAppraisalSeasonOpeningDate(
      companyId: $companyId
      country: $country
      year: $year
      openingMonth: $openingMonth
      openingYear: $openingYear
    )
  }
`
